// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"DetailsTitle__wrapper__1zEY5 _headers__headerPrimaryLarge__ZHchg","closeWrapper":"DetailsTitle__closeWrapper__2cCYS","close":"DetailsTitle__close__3QvRs","headerBottomBorder":"DetailsTitle__headerBottomBorder__lwNOs"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/newPdp/components/Shipping/ShippingDetailsModal/DetailsTitle.scss
// module id = 1723
// module chunks = 4 14